import React, { useState } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { merchantsById } from "../../Merchants";
import PropTypes from "prop-types";
import { Icon } from "ccui-framework";
import { SecondaryButton } from "../../Button";
import { ConfirmCloseModal } from "./ConfirmCloseModal";
import { removeCard } from "../thunk";

const Td = styled.td`
  text-align: center;
  padding: 6px;
  font-size: 11px;
  color: #000;
  font-weight: normal;

  &:first-of-type {
    text-align: left;
  }
`;

const Img = styled.img`
  height: 40px;
  cursor: pointer;
  margin-right: 10px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: end;
`;
const Button = styled(SecondaryButton)`
  width: 40px;
`;

const Card = ({ card, setCanEdit }) => {
  const dispatch = useDispatch();
  const merchants = useSelector(merchantsById);
  const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);
  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      currencySign: "accounting",
      style: "currency",
      currency: "USD",
    }).format(amount);

  if (!merchants[card.merchant]) {
    return null;
  }

  return (
    <>
      <Td>
        <Img src={merchants[card.merchant].image ?? ""} />
        {merchants[card.merchant].name ?? ""}
      </Td>
      <Td>{card.number ?? "N/A"}</Td>
      <Td>{card.pin ?? "N/A"}</Td>
      <Td>{card.refId ?? "N/A"}</Td>
      <Td>{formatCurrency(card.enterValue)}</Td>
      <Td>{card.percentage}%</Td>
      <Td>{formatCurrency(card.cashValue)}</Td>
      <Td>
        {merchants[card.merchant].submissionMethod.charAt(0).toUpperCase() +
          merchants[card.merchant].submissionMethod.slice(1)}
      </Td>
      <Td>
        <Actions>
          <Button onClick={setCanEdit}>
            <Icon name="fa-edit" />
          </Button>
          <Button onClick={() => setConfirmCloseOpen(true)}>
            <Icon name="fa-trash-alt" />
          </Button>
          <ConfirmCloseModal
            doClose={() => setConfirmCloseOpen(false)}
            isOpen={confirmCloseOpen}
            doDelete={() => {
              dispatch(removeCard(card.id));
            }}
          />
        </Actions>
      </Td>
    </>
  );
};

Card.propTypes = {
  card: PropTypes.object.isRequired,
  setCanEdit: PropTypes.func.isRequired,
};

export { Card };
